import { fetchNewAuthenticationRoles } from 'actions/OnboardingActions';

export function reauthenticate(): ApiAction {
  return fetchNewAuthenticationRoles();
}
